<script>
import {useRoute, useRouter} from "vue-router";
import {ref, watch} from "@vue/runtime-core";
import libraryCards from "@/views/EmotionLibrary/libraryCards";
import router from "@/router";
import {onMounted} from "vue";

export default {
  name: "EmotionDetail.vue",
  setup() {
    const route = useRoute();
    const router = useRouter()
    let currentEmotion = ref();

    const loadEmotion = (emotionKey) => {
      if (!emotionKey || !libraryCards[emotionKey]) {
        router.replace('/library/list')
        return
      }

      currentEmotion.value = libraryCards[emotionKey]
    }

    watch(
        () => route.params.emotion,
        (newEmotion) => {
          loadEmotion(newEmotion)
        },
        { immediate: true }
    )

    onMounted(() => {
      let video = document.querySelector('.video_wrapper');
      video.scrollIntoView({ behavior: "smooth", block: "center"});
    });

    const getVideo = (name) => {
      return `${process.env.VUE_APP_BACK}/videos/${name}.mp4`
    }

    const getVideoPoster = (name) => {
      return `${process.env.VUE_APP_BACK}/videos/posters/${name}.jpg`
    }

    const findNextEmotion = (emotion) => {
      const keys = Object.keys(libraryCards);
      const currentIndex = keys.indexOf(emotion);
      const newEmotion = (currentIndex + 1 >= keys.length) ? keys[0] : keys[currentIndex + 1];
      router.push(`/library/emotion/${newEmotion}`);
    }

    return {
      currentEmotion,
      getVideo,
      getVideoPoster,
      findNextEmotion
    }
  }
}
</script>

<template>
  <div class="view-container">
    <div class="card staff-table">
      <div class="card-header card-header-divider header_green">
        <div class="card-title">{{ currentEmotion.title }}</div>
      </div>
      <div class="card-body emotion_main_wrapper">
        <div class="video_wrapper">
          <video :key="getVideo(currentEmotion.title)"
                 controls
                 muted
                 playsinline
                 preload="metadata"
                 class="video"
                 :poster="getVideoPoster(currentEmotion.title)"
          >
            <source :src="getVideo(currentEmotion.title)" type="video/mp4">
          </video>
        </div>
        <div class="emotion-navigation_wrapper">
          <button class="btn btn-accent btn-ico emotion-button" @click="() => findNextEmotion(currentEmotion.type)">
            Смотреть другую эмоцию
          </button>
          <router-link
              :to="{ name: 'emotion-library' }"
              class="btn btn-accent btn-ico emotion-button"
          >
            К Библиотеке
          </router-link>
        </div>
        <div class="description">
          <h2 class="sub_header">Что это?</h2>
          <div class="description_wrapper">
            <p v-for="(desc, key) in currentEmotion.description.split('\n')" :key="key">
              {{ desc }}
            </p>
          </div>
        </div>
        <div class="demonstration_description">
          <h2 class="sub_header">Как проявляется</h2>
          <p v-if="currentEmotion.demonstration_description">
            {{ currentEmotion.demonstration_description }}
          </p>
          <ul class="demonstration_list">
            <li v-for="demonstration in currentEmotion.demonstration" :key="demonstration">
              {{ demonstration }}
            </li>
          </ul>
        </div>
        <div class="function_description">
          <h2 class="sub_header">Функции</h2>
          <ul class="demonstration_list">
            <li v-for="func in currentEmotion.functions" :key="func">
              {{ func }}
            </li>
          </ul>
        </div>
        <div class="reaction_description">
          <h2 class="sub_header">Реакция</h2>
          <div v-if="!Array.isArray(currentEmotion.reactions)" class="reaction_text_wrapper">
            <p v-for="(desc, key) in currentEmotion.reactions.split('\n')" :key="key" class="reaction_text">
              {{ desc }}
            </p>
          </div>
          <ul v-else class="reaction_list">
            <li v-for="reaction in currentEmotion.reactions" :key="reaction">
              {{ reaction }}
            </li>
          </ul>
        </div>
        <div class="usage_description">
          <h2 class="sub_header">Использование в решении задач</h2>
          <div v-if="!Array.isArray(currentEmotion.usage)" class="usage_text_wrapper">
            <p v-for="(desc, key) in currentEmotion.usage.split('\n')" :key="key" class="usage_text">
              {{ desc }}
            </p>
          </div>
          <div v-else class="additional_usage_wrapper">
            <div v-for="(paragraph, key) in currentEmotion.usage" :key="key">
              <h3 class="additional_usage_header">
                {{ paragraph.header }}
              </h3>
              <div class="usage_text_wrapper">
                <p v-for="(desc, key) in paragraph.body.split('\n')" :key="key" class="usage_text">
                  {{ desc }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.emotion-navigation_wrapper {
  margin-top: 10px;
  display: flex;
  column-gap: 15px;
  row-gap: 10px;
  flex-wrap: wrap;
}

.header_green {
  font-size: 24px;
  font-weight: bold;
  color: #51bb50;
}

.video_wrapper {
  text-align: center;
  scroll-snap-align: start;
}

.video {
  height: 350px;
}

.emotion_main_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.demonstration_list,
.reaction_list {
  padding-left: 20px;
}

.demonstration_list li,
.reaction_list li {
  list-style: initial;
}

.description_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  text-align: justify;
}

.reaction_text_wrapper,
.usage_text_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  text-align: justify;
}

.sub_header {
  margin-bottom: 5px;
  font-size: 18px;
  font-style: italic;
}

.reaction_text,
.usage_text {
  text-align: justify;
}

.additional_usage_wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.additional_usage_header {
  font-size: 15px;
  margin-bottom: 5px;
}

@media (max-width: 1000px) {
  .video {
    height: 250px;
  }
}

@media (max-width: 850px) {
  .video {
    height: 180px;
  }
}
</style>